var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpookyswap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    className: "sc-bdnxRM fHFrls",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(1.96026 0 0 1.97915 58.4309 39.6851)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#633001",
    d: "m-23.59759,-15.05157c-0.5,-2.6 1.5,-5 4.1,-5c2.3,0 4.2,1.9 4.2,4.2l0,5.2c0.6,0 1.2,-0.1 1.8,-0.1s1.1,0 1.7,0.1l0,-5.2c0,-2.3 1.9,-4.2 4.2,-4.2c2.6,0 4.6,2.4 4.2,5l-1.1,6.1c3.9,1.7 6.9,4.7 6.9,8.4l0,2.3c0,3.1 -2,5.7 -4.9,7.4c-2.9,1.8 -6.7,2.8 -11,2.8s-8.1,-1 -11,-2.8c-2.8,-1.7 -4.8,-4.3 -4.8,-7.4l0,-2.3c0,-3.7 2.9,-6.7 6.8,-8.4l-1.1,-6.1zm17.6,6.9l1.3,-7.2c0.3,-1.8 -1,-3.5 -2.9,-3.5c-1.6,0 -2.9,1.3 -2.9,2.9l0,6.6c-0.4,-0.1 -0.9,-0.1 -1.3,-0.1c-0.6,0 -1.1,-0.1 -1.7,-0.1s-1.2,0 -1.8,0.1c-0.4,0 -0.9,0.1 -1.3,0.1l0,-6.5c0,-1.6 -1.3,-2.9 -2.9,-2.9c-1.8,0 -3.2,1.7 -2.8,3.5l1.3,7.2c-4.2,1.6 -7,4.4 -7,7.6l0,2.3c0,4.9 6.5,8.9 14.5,8.9s14.5,-4 14.5,-8.9l0,-2.3c0.1,-3.3 -2.7,-6.1 -7,-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fillRule: "nonzero",
    fill: "#fedc90",
    d: "m1.10241,1.74843c0,4.9 -6.5,8.9 -14.5,8.9s-14.5,-4 -14.5,-8.9l0,-2.3l29.1,0l0,2.3l-0.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#d1884f",
    d: "m-22.29759,-15.25157c-0.4,-1.8 1,-3.5 2.8,-3.5c1.6,0 2.9,1.3 2.9,2.9l0,6.6c1,-0.1 2,-0.2 3.1,-0.2c1,0 2,0.1 3,0.2l0,-6.6c0,-1.6 1.3,-2.9 2.9,-2.9c1.8,0 3.2,1.7 2.9,3.5l-1.3,7.2c4.2,1.6 7.1,4.4 7.1,7.6c0,4.9 -6.5,8.9 -14.5,8.9s-14.5,-4 -14.5,-8.9c0,-3.2 2.8,-6 7,-7.6l-1.4,-7.2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    fillRule: "nonzero",
    fill: "#633001"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m-17.49759,-1.15157c0,1.3 -0.7,2.4 -1.6,2.4s-1.6,-1.1 -1.6,-2.4s0.7,-2.4 1.6,-2.4s1.6,1.1 1.6,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m-6.39759,-1.15157c0,1.3 -0.7,2.4 -1.6,2.4s-1.6,-1.1 -1.6,-2.4s0.7,-2.4 1.6,-2.4s1.6,1.1 1.6,2.4z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpookyswap);
export default __webpack_public_path__ + "static/media/spookyswap.5f160460.svg";
export { ForwardRef as ReactComponent };